import { useQuery } from "@apollo/client";
// Libraries
import { Box, Center, Flex, Image, Skeleton, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useEmblaCarousel } from "embla-carousel/react";
import React from "react";
import { GET_STUDENT_MEETINGS } from "../../../graphql/queries/class";
import { initZoom } from "../../Live";
// Components
// import Loader from "../UI/Loader";
import { NetworkError } from "../../UI/Error";
import Empty from "./Empty";

dayjs.extend(relativeTime); // RelativeTime adds .from .to .fromNow .toNow APIs to formats date to relative time strings

interface Props {
  classesData: any;
  isLoading: boolean;
  error: any;
  refetch?: any;
}

const SkeletonLoader = () => <Skeleton h="64px" minW={{ base: "90%", md: "276px" }} maxW={{ base: "90%", md: "276px" }} />;

const ScheduledClassItem = ({ topic, meeting_id, password, start_time, meeting_type, onNavigate }) => (
  <Flex
    align="center"
    pos="relative"
    backgroundColor="#FFFFFF"
    boxShadow="0px 0px 1px rgba(0, 0, 0, 0.5)"
    borderRadius="8px"
    w="100%"
    p="8px"
    cursor="pointer">
    <Box backgroundColor="blue.500" p="4px" borderRadius="8px" mr="10px" minW="46px">
      <Image src="/video_camera.png" height="40px" />
    </Box>
    <Box overflow="auto">
      <Text fontWeight="700" fontSize="lg" lineHeight="18px" isTruncated onClick={onNavigate}>
        {topic}
      </Text>
      <Text fontWeight="700" fontSize="sm" color="blue.500" isTruncated onClick={onNavigate}>
        {meeting_type === "scheduled" ? `Starts in ${start_time && dayjs(start_time).fromNow(true)}` : `Started`}
      </Text>
    </Box>
  </Flex>
);

const ScheduledMeetings = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
  });

  const { loading, error, data } = useQuery(GET_STUDENT_MEETINGS, {
    pollInterval: 3000,
  });

  // console.log("data is here", data);

  React.useEffect(() => {
    if (emblaApi) {
      // Embla API is ready
    }
  }, [emblaApi]);

  if (error) {
    <Center h="100%">
      <NetworkError />
    </Center>;
  }

  // Display content classes
  return (
    <Box>
      <Box py={4}>
        <VStack spacing={4} w="100%">
          {loading && (
            <>
              <SkeletonLoader />
              <SkeletonLoader />
              <SkeletonLoader />
            </>
          )}

          {data && data?.student_meetings?.edges.length === 0 && <Empty />}

          {data &&
            data.student_meetings &&
            data.student_meetings.edges.map((m) => (
              <ScheduledClassItem
                topic={m.topic}
                password={m.password}
                meeting_id={m.meeting_id}
                start_time={m.start_time}
                meeting_type={m.meeting_type}
                onNavigate={() => {
                  if (m?.meeting_id && m?.password) {
                    initZoom(m.meeting_id, m.password);
                  } else {
                    if (typeof window !== "undefined") {
                      window.open(m?.join_url, "_blank");
                    }
                  }
                }}
              />
            ))}
        </VStack>
      </Box>
    </Box>
  );
};

export default ScheduledMeetings;
